import React, {useEffect, useMemo, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import {fetchConfigs, fetchFeatures} from "../../NetworkUtils";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Select, {SelectOption} from "@amzn/meridian/select";
import Button from "@amzn/meridian/button";
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint} from "../../Utils";
import Alert from "@amzn/meridian/alert";
import Tooltip from "@amzn/meridian/tooltip";
import Input from "@amzn/meridian/input";
import {ALERT_TYPES, CONFIG_TYPES} from "../../Constants";

const OrderConfigurations = (props) => {
    const [configs, setConfigs] = useState([]);
    const [featureId, setFeatureId] = useState();
    const [mcmId, setMcmId] = useState();
    const [showMcmButton, setShowMcmButton] = useState(true);
    const [featureSearchQuery, setFeatureSearchQuery] = useState();
    const [features, setFeatures] = useState([]);
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const successAlert = {visible: true, text: "Order Configurations request successful.", type:ALERT_TYPES.SUCCESS};
    const warningAlert = {visible: true, text: "Order Configurations request received.", type:ALERT_TYPES.WARNING};

    useEffect(() => {
        // redirected from CreateG2S2Configuration
        try {
            setFeatureId(props.location.state.featureId);
            setMcmId(props.location.state.mcmId);
            setShowMcmButton(false);
        } catch(error) {}

        if (featureId) {
            fetchConfigs(featureId, CONFIG_TYPES.G2S2).then(response => setConfigs(response.map(config => config.name)));
        } else {
            // landed directly through URL
            fetchFeatures().then(response => setFeatures(response));
        }
    }, []);

    useEffect(() => {
        if (featureId) {
            fetchConfigs(featureId, CONFIG_TYPES.G2S2).then(response => setConfigs(response.map(config => config.name)));
        }
    }, [featureId]);

    const searchRegExpFeature = useMemo(
        () => new RegExp(featureSearchQuery, "i"),
        [featureSearchQuery]
    )

    const matchedFeature = features.filter(
        feature => !featureSearchQuery || searchRegExpFeature.test(feature)
    )

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(configs);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setConfigs(items);
    }

    const orderConfigurations = () => {
        setAlert(warningAlert);
        const params = {featureId: featureId, configStore: "G2S2", orderedConfigurations: configs, mcmId: mcmId};
        (async () => {
            const headers = await getHeadersForNFMS("OrderConfigurations");
            axios
                .post(getNFMSEndpoint(), params, headers)
                .then((response) => {
                    if (response.status === 200) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();
    }

    return (
        <div classID="App">
            <Row alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="reorderConfig.feature" defaultMessage="Feature"/>
                    </Text>
                    <Select searchQuery={featureSearchQuery} onSearch={setFeatureSearchQuery}
                            value={featureId} onChange={setFeatureId} placeholder="Select Feature" width={400}>
                            {matchedFeature.map(feature => (
                            <SelectOption label={feature} value={feature} key={feature}/>
                            ))}
                    </Select>
                </Column>
            </Row>

            {showMcmButton ?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="orderConfig.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={mcmId} onChange={setMcmId} type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>
            : null}

            {configs.length > 0 ?
                <Row alignmentVertical="top" spacingInset="large none small none">
                    <Tooltip position="right" title="Order of execution matters in case of Foreign Key relationships between G2S2 tables">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="reorderConfig.directive"
                                              defaultMessage="Please arrange the G2S2 Configurations in the order they should be executed."/>
                        </Text>
                    </Tooltip>
                </Row>
            : null}

            <Row alignmentVertical="top" spacingInset="small none medium none">
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="list">
                        {(provided) => (
                            <ul className={"list"} {...provided.droppableProps} ref={provided.innerRef}>
                                {configs.map((config, index) => (
                                    <Draggable key={config} draggableId={config} index={index}>
                                        {(provided) => (
                                            <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                <Box type="outline" spacingInset="small">
                                                    <Text type="b300">{config}</Text>
                                                </Box>
                                            </li>
                                        )}
                                    </Draggable>
                                ))}
                            {provided.placeholder}
                            </ul>
                        )}
                    </Droppable>
                </DragDropContext>
            </Row>

            {configs.length > 0 ?
                <Row alignmentVertical="top" spacingInset="large large large none">
                    <Button onClick={orderConfigurations}>
                        <FormattedMessage id="reorderConfig.next" defaultMessage="Save Order"/>
                    </Button>
                </Row>
            : null}
            <Row alignmentVertical="top" spacingInset="none none medium none">
                {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
            </Row>
        </div>
    );
}

export default injectIntl(OrderConfigurations);


// WEBPACK FOOTER //
// ./src/components/order-configs/OrderConfigurations.js